import React, { useEffect, useState } from "react";

interface PdfViewerProps {
  previewFile: File;
  totalPages?: number;
  onLoad?: () => void;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ previewFile, totalPages = 1, onLoad }) => {
  const [pdfFileUrl, setPDFFileUrl] = useState<string | null>(null);

  const handlePDFFileUrl = async () => {
    const fileUrl = URL.createObjectURL(previewFile);
    setPDFFileUrl(fileUrl);
  };

  useEffect(() => {
    handlePDFFileUrl();
    return () => {
      if (pdfFileUrl) {
        URL.revokeObjectURL(pdfFileUrl);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewFile]);

  return (
    <div className="w-full bg-secondary-50 rounded-lg border border-secondary-200 p-4 overflow-auto">
      {pdfFileUrl ? (
        <iframe
          src={`${pdfFileUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
          title="PDF Viewer"
          className="w-full border-0 rounded-lg"
          style={{ height: `${totalPages * 988 + 1}px`, minHeight: "600px" }}
          onLoad={onLoad}
        >
          This browser does not support PDFs. Please download the PDF to view it:{" "}
          <a href={pdfFileUrl} className="text-primary-600 hover:underline">
            Download PDF
          </a>
        </iframe>
      ) : (
        <p className="text-secondary-500 text-center py-8">No PDF loaded</p>
      )}
    </div>
  );
};

export { PdfViewer };
